import axios from "axios";
import { PUBLIC_TOOLS_API, publicToolHeaders } from "./publicAudioTools";

export const PITCH_API = `${PUBLIC_TOOLS_API}/pitch-tempo`;
export const wait = (ms, signal) => new Promise((resolve, reject) => {
  const abort = () => { window.clearTimeout(timer); reject(new DOMException("Cancelled", "AbortError")); };
  const timer = window.setTimeout(() => { signal?.removeEventListener("abort", abort); resolve(); }, ms);
  if (signal?.aborted) abort();
  else signal?.addEventListener("abort", abort, { once: true });
});

export async function uploadChunks(file, session, signal, onProgress) {
  const headers = publicToolHeaders(session);
  const status = await axios.get(`${PITCH_API}/${session.session_id}/status`, { headers, signal });
  let offset = status.data.received_bytes;
  while (offset < file.size) {
    const block = file.slice(offset, offset + session.chunk_bytes);
    const hash = await crypto.subtle.digest("SHA-256", await block.arrayBuffer());
    const sha256 = Array.from(new Uint8Array(hash), (byte) => byte.toString(16).padStart(2, "0")).join("");
    let response;
    for (let attempt = 0; attempt < 4; attempt += 1) {
      try {
        response = await axios.put(`${PITCH_API}/${session.session_id}/chunks?offset=${offset}`, block, {
          headers: { ...headers, "Content-Type": "application/octet-stream", "X-Chunk-SHA256": sha256 }, signal,
          onUploadProgress: ({ loaded }) => onProgress(Math.min(100, (offset + loaded) / file.size * 100)),
        });
        break;
      } catch (error) {
        if (signal.aborted || attempt === 3 || (error.response && ![409, 429, 503].includes(error.response.status))) throw error;
        await wait(500 * (attempt + 1), signal);
      }
    }
    offset = response.data.received_bytes;
    onProgress(offset / file.size * 100);
  }
}

export async function pollJob(session, category, signal, onProgress) {
  while (!signal.aborted) {
    const response = await axios.get(`${PITCH_API}/${session.session_id}/status`, { headers: publicToolHeaders(session), signal });
    const job = response.data[category];
    onProgress(job || { percent: 0, stage: category });
    if (job?.state === "ready") return response.data;
    if (job?.state === "error") throw new Error(job.message);
    await wait(700, signal);
  }
  throw new DOMException("Cancelled", "AbortError");
}
